import React from "react";
import { Reveal, Stagger, staggerItem } from "./motion/Reveal";
import { motion } from "framer-motion";
import { Flame, Moon, Sparkles, Brain } from "lucide-react";

const SPACES = [
    {
        icon: Flame,
        title: "Canal de Velas",
        body: "Comparte los restos de tus velas y recibe orientación para comprender su posible significado.",
    },
    {
        icon: Moon,
        title: "Canal de Astrología",
        body: "Una astróloga profesional comparte las energías astrológicas de cada momento.",
    },
    {
        icon: Sparkles,
        title: "Espiritualidad con Lidia",
        body: "Reflexiones, meditaciones y prácticas para cuidar tu energía y tu alma.",
    },
    {
        icon: Brain,
        title: "Mentalidad con Santi",
        body: "Ejercicios sobre creencias, mente y crecimiento personal que acompañan tu proceso.",
    },
];

export default function Spaces() {
    return (
        <section id="espacios" className="relative py-20 sm:py-28 bg-alma-ivory">
            <div className="max-w-[1100px] mx-auto px-6 sm:px-8">
                <Reveal>
                    <div className="text-center max-w-2xl mx-auto mb-12">
                        <span className="text-xs tracking-[0.35em] uppercase text-alma-goldDeep font-medium">
                            Espacios que te acompañan
                        </span>
                        <h2 className="mt-5 font-serif text-4xl sm:text-5xl leading-[1.05] text-alma-ink">
                            Todo lo que tu alma
                            <span className="italic text-alma-goldDeep"> necesita, en un solo lugar.</span>
                        </h2>
                    </div>
                </Reveal>

                <Stagger className="grid sm:grid-cols-2 gap-5">
                    {SPACES.map(({ icon: Icon, title, body }, i) => (
                        <motion.div
                            key={i}
                            variants={staggerItem}
                            className="bg-alma-white border border-alma-mist rounded-3xl p-8 flex gap-5 hover:-translate-y-1 transition-transform duration-500"
                        >
                            <div className="shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-full bg-alma-ivory text-alma-goldDeep">
                                <Icon className="h-5 w-5" strokeWidth={1.5} />
                            </div>
                            <div>
                                <h3 className="font-serif text-2xl text-alma-ink leading-tight">{title}</h3>
                                <p className="mt-2 font-sans text-[15px] text-alma-slate leading-relaxed">{body}</p>
                            </div>
                        </motion.div>
                    ))}
                </Stagger>
            </div>
        </section>
    );
}
